var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar" }, [
    _c("div", { staticClass: "right-menu" }, [
      _c("div", {
        staticClass: "logo",
        style: { backgroundImage: "url(" + _vm.logoImg + ")" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "avatar-container right-menu-item hover-effect" },
        [
          _vm.env !== "offline"
            ? _c(
                "a",
                {
                  staticClass: "link-course",
                  attrs: { href: "/static/course.mp4", target: "__blank" }
                },
                [_vm._v("验收平台使用说明")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("Progress"),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" }
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("img", {
                  staticClass: "head",
                  attrs: { src: _vm.userInfo.headimg }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "username" }, [
                  _c("p", { staticClass: "usernick" }, [
                    _vm._v(
                      _vm._s(_vm.userInfo.nickname) +
                        "(" +
                        _vm._s(_vm.userInfo.uid) +
                        ")"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", [
                    _c(
                      "span",
                      {
                        staticStyle: { display: "block" },
                        on: { click: _vm.logout }
                      },
                      [_vm._v("退出")]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-797e31be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-797e31be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Navbar.vue
// module id = null
// module chunks = 